import { IMdCmSearchFields } from "../types/FmsTypes";
import { MdEnableStatusEnum } from "../types/FmsEnums";

//系统标识
export const CLIENT_APP_CODE = "mdm";
export const DEFAULT_PAGE_SIZE = 15;
export const DEFAULT_FIRST_PAGE_NUM = 1;
export const DEFAULT_REQUEST_TIMEOUT = 30000;

//API请求环境
const baseRequestUrl = {
    "DEV": "https://test-api-2.laoniuche.cn",
	"STAGE": "https://test-api-2.laoniuche.cn",
	//"TEST": "https://test-api-2.laoniuche.cn",
    "TEST": "https://test-api-2.laoniuche.cn",
	"PROD": "https://api-2.yunhaogroup.com"
}

//根据环境变量自动获取请求地址
export const getBaseRequestUrl = () => {
    //自动选择环境
    //....
    const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
    return baseRequestUrl[REACT_APP_ENV ?? "DEV"]
};

//根据环境变量自动获取图片查看地址
export const getBaseImgLookUrl = (md5: string) => {
    //自动选择环境
    return `${getBaseRequestUrl()}/fsrv/fetch/${md5}?Authorization=${getToken()}`
}

//根据环境变量自动获取图片上传地址
export const getBaseImgUploadUrl = () => {
    //自动选择环境
    return `${getBaseRequestUrl()}/fsrv/upload_file?Authorization=${getToken()}`
}

//根据环境变量自动获取图片上传地址
export const getBaseUploadData = () => {
    return {
        appCode: CLIENT_APP_CODE,
        fileMode: 0,
    }
}


//服务器自定义错误码
export const INTERNAL_SERVER_ERROR_CODE = 500;
//token存储KEY值
export const TOKEN_KEY = "token";
//获取token
export const getToken = () => {
    return sessionStorage.getItem(TOKEN_KEY) ?? "default-token-str"
};
//存储token
export const setToken = (token: string) => {
    sessionStorage.setItem(TOKEN_KEY, token)
};

//主数据通用字段定义
export const defaultMdCmParam: IMdCmSearchFields = {
    sourceApp: "mdm",
    sourceAuthKey: "",
    branch: "main",
    ver: undefined,
    enable: MdEnableStatusEnum.ENABLE,
};
